import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=6cda1d82&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda1d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cda1d82')) {
      api.createRecord('6cda1d82', component.options)
    } else {
      api.reload('6cda1d82', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=6cda1d82&scoped=true", function () {
      api.rerender('6cda1d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/Notifications.vue"
export default component.exports